module.exports = __webpack_public_path__ + "static/media/NN-Mug-banner.aa512400.jpg";